import { Component } from '@angular/core';
import { Form, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  working: boolean = false;
  complete: boolean = false;
  form: FormGroup;

  constructor(private fb: FormBuilder, private authService: AuthService) {
    this.form = this.fb.group({
      email: ['', Validators.required],
    });
  }

  get formControl() {
    return this.form.controls;
  }

  submit() {
    let val = this.form.value;
    if (val.email) {
      this.working = true;
      this.authService.forgotPassword(val.email)
        .subscribe({
          next: () => {
            this.complete = true;
            this.working = false;
          }
        })
    }
  }
}
